import type { ICampaignAnalyticMapping } from '../types';

import { CAMPAIGN_ANALYTIC_MAPPING, CAMPAIGN_METRIC_TOOLTIP_BY_MODE } from '../constants';
import { EAnalyticMode } from '~/modules/analytics/types';
import { ICampaignMetricKey } from '../types';

export const getCampaignAnalyticMapping = (
  metricKey?: ICampaignMetricKey,
): ICampaignAnalyticMapping => {
  const defaultData: ICampaignAnalyticMapping = {
    metricFuncKey: 'getDefaultMetric',
    metricDataKey: 'defaultMetric',
    title: 'Unknown',
    metricKey: ICampaignMetricKey.SESSION,
  };

  return CAMPAIGN_ANALYTIC_MAPPING.find((item) => item.metricKey === metricKey) ?? defaultData;
};

export const getCampaignTooltipBy = (
  metricKey: ICampaignMetricKey,
  analyticMode?: EAnalyticMode,
) => {
  return CAMPAIGN_METRIC_TOOLTIP_BY_MODE[analyticMode || EAnalyticMode.FIRST_SESSION][metricKey];
};
